import React, { useState } from "react";
import Parser from "html-react-parser";

const FAQ = () => {
  const [answerIndex, setAnswerIndex] = useState(null);
  const [toggle, setToggle] = useState(false);

  const datas = [
    {
      id: 1,
      question: "Can I retake the health questionnaire I completed during signup?",
      answer: `Yes, you can retake it from the 'Health Profile' menu.
        In the 'Health Profile' screen, select the Edit button for 'Physical & Medical Info' or 'Dietary Habits' to update your answers.
        Your updated information will be reflected in your nutrition goals and recommended meal plans.`,
    },
    {
      id: 2,
      question: "Will my recommended meal plan change if my weight changes?",
      answer: `Yes, when you update your weight, you'll receive a new meal plan tailored to your current weight.
        You can update your weight in 'Health Log', and it will be reflected in your nutrition goals and meal recommendations.
        You can also update your weight by retaking the questionnaire in 'Health Profile'.`,
    },
  ];
  const FAQList = (el, idx) => {
    return (
      <>
        <div className="flex items-start">
          <span className="pr-2 text-body3_600 text-orange_180">Q.</span>
          <p className="text-body3_600">{el.question}</p>
        </div>
        <img
          src="/images/mobile/icon/arrow_right.svg"
          className={
            "transition duration-150 ease-linear" +
            (answerIndex === idx && toggle ? " rotate-90" : " rotate-0")
          }
          alt="right_arrow"
        />
      </>
    );
  };
  return (
    <div>
      <ul>
        {datas?.map((el, idx) => (
          <li key={el.id}>
            <div
              className="flex p-6 bg-white border-b gap-x-2"
              key={el.id}
              onClick={() => {
                setAnswerIndex(idx);
                if (toggle && answerIndex === idx) {
                  setToggle(false);
                } else {
                  setToggle(true);
                }
              }}
            >
              {FAQList(el, idx)}
            </div>
            {answerIndex === idx && toggle && (
              <div className="p-6 bg-gray_95">
                <div className="flex items-start">
                  <span className="pr-2 text-body3_600 text-correct">A.</span>
                  <p className="text-body3_600">
                    {el.answer ? Parser(el.answer) : null}
                  </p>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQ;
